export const af: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Kontroleskerm',
  'nav.focus': 'Daaglikse Fokus & Padkaart',
  'nav.ai_assistant': 'Geoutomatiseerde Operasionele Enjin',
  'nav.calendar': 'Google Kalender',
  'nav.book': 'Openbare Besprekingsblad',
  'nav.bookings': 'Besprekings & Inkomste',
  'nav.invoices': 'Fakture',
  'nav.expenses': 'Besigheidsuitgawes',
  'nav.settings': 'Besigheid- & Belasting-HK',
  'nav.billing': 'Intekening & Planne',
  'nav.j_lens': 'J-Lens Kluis',
  'nav.concept': 'Konsep & Filosofie',
  'nav.what_is': 'Wat is AzuraOS?',
  'nav.export': 'Uitvoer & Rugsteun',
  'nav.menu': 'Kieslys',
  'nav.welcome': 'Welkom & BYOK-Kern',
  'nav.app_stack_modules': 'Stelselmodules',
  'nav.core_engines': '8 Kern-enjins',
  'nav.manifesto': 'Stigterstelsel & Manifes',
  'nav.workspace_actions': 'Werkspasie-aksies',
  'nav.export_records': 'Voer Rekords Uit',
  'nav.load_demo': 'Laai Demo-Sandput',
  'nav.partnerships': 'Vennootskappe & Ondersteuning',
  'nav.request_partnership': 'Versoek Vennootskapstoegang',
  'nav.partner_subtext': 'Bankintegrasies, kohorte en borgskappe',
  'nav.interface_language': 'Koppelvlaktaal',
  'nav.legal_trust': 'Regs & Vertroue',
  'nav.security': 'Sekuriteit',
  'nav.faqs': 'Gereelde Vrae',
  'nav.terms': 'Termes & Voorwaardes',
  'nav.privacy': 'Privaatheid',
  'nav.refund': 'Terugbetalingsbeleid',
  'nav.contact': 'Kontak',
  'nav.report_bug': 'Rapporteer Fout',
  'nav.invite_founder': '+ Nooi Stigter Uit',
  'nav.privacy_active': 'Privaatheidsmodus: AKTIEF',
  'nav.privacy_off': 'Privaatheidsmodus: AF',
  'nav.masked': 'Versteek',
  'nav.visible': 'Sigbaar',
  'nav.live_margin': 'LEWENDIGE OPERASIONELE MARGINE',
  'nav.target_safe_zone': 'Veilige Sone Teiken:',
  'nav.close_menu': 'Maak Kieslys Toe',
  'nav.founder_access': 'Teken In / Stigterstoegang',
  'nav.private_vault': 'Privaat Kluis Gekoppel',
  'nav.master_access': 'Meester Stigterstoegang',
  'nav.lifetime': 'Lewenslank',
  'nav.pro_active': 'Sovereign Pro Aktief',
  'nav.trial_days': '7-Dae Proeflopie: {days} dae oor',
  'nav.trial_expired': 'Proeflopie Verval',
  'nav.manage': 'Bestuur →',
  'nav.upgrade': 'Gradeer Op →',
  'nav.unlock_pro': 'Ontsluit Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Goeiemôre',
  'dash.greeting_afternoon': 'Goeiemiddag',
  'dash.greeting_evening': 'Goeienaand',
  'dash.value_prop': 'Veelvoudige inkomstestrome op een plek: Voer 1 inkomstestroom en 1 uitgawe in om jou netto winsmarge intyds te sien.',
  'dash.manage_streams': 'Bestuur Inkomstestrome',
  'dash.close_streams': 'Sluit Strome',
  'dash.income': 'Totale Inkomste',
  'dash.collected': 'Ontvang',
  'dash.unpaid': 'Uitstaande',
  'dash.expenses': 'Besigheidsuitgawes',
  'dash.across_records': 'Oor alle rekords',
  'dash.net_profit': 'Netto Wins (Net Profit)',
  'dash.daily_focus_title': 'Daaglikse Fokus & Inkomste-aksieplan',
  'dash.daily_focus_sub': 'Hoë-impak stigterstake wat wins en groei aandryf',
  'dash.open_focus': 'Maak Fokus-Padkaart Oop',
  'dash.stream_profitability': 'Winsgewendheid per Stroom',
  'dash.stream_sub': '1 diens of veelvoudige strome • Lewendige margenaspeuring',
  'dash.quick_actions': 'Vinnige Aksies',
  'dash.add_booking': 'Voeg Bespreking By',
  'dash.add_booking_desc': 'Teken nuwe kliënte-inkomste aan',
  'dash.add_expense': 'Teken Uitgawe Aan',
  'dash.add_expense_desc': 'Boek operasionele en besigheidskoste',
  'dash.add_insight': 'Voeg Insig By',
  'dash.add_insight_desc': 'Teken nuwe J-Lens reël aan',
  'dash.quick_add_title': 'Vinnige Inskrywing',
  'dash.quick_revenue': '+ VINNIGE INKOMSTE (BESPREKING)',
  'dash.quick_expense': '+ VINNIGE UITGAWE (GROOTBOEK)',
  'dash.recent_activity': 'Onlangse Aktiwiteit',
  'dash.no_activity': 'Geen onlangse aktiwiteit aangeteken nie. Gebruik die vinnige aksies hierbo om te begin.',
  'dash.spotlight_insight': 'Kollig J-Lens Insig',
  'dash.access_vault': 'Besoek Kluis →',
  'dash.sandbox_active': 'Sandput Aktief',
  'dash.load_demo_data': 'Laai Demo-data',
  'dash.clear_sandbox': 'Maak Sandput Skoon',
  'dash.clear_confirm': 'Vee data uit?',
  'dash.yes_clear': 'Ja, vee uit',
  'dash.cancel': 'Kanselleer',

  // Bookings View
  'bookings.title': '📅 Besprekings & Inkomstestrome',
  'bookings.subtitle': 'Onafhanklike kliënte-inkomstekanale',
  'bookings.public_page': 'Openbare Besprekingsblad',
  'bookings.import_csv': 'Voer CSV In',
  'bookings.add_button': 'Voeg Bespreking By',
  'bookings.client_link_title': 'Kliënt Self-Skeduleringskakel',
  'bookings.client_link_desc': 'Deel skeduleringskakels met kliënte vir outomatiese besprekings en Google Kalender-sinchronisasie.',
  'bookings.link_active': 'Aktief',
  'bookings.generate_custom_link': '⚡ Genereer Pasgemaakte Pryskakel',
  'bookings.hide_custom_link': 'Versteek Pryskakel',
  'bookings.copy_standard_link': 'Kopieer Standaardskakel',
  'bookings.copied_link': 'Skakel gekopieer!',
  'bookings.preview': 'Voorskou',
  'bookings.search_placeholder': 'Soek volgens kliënt of diens...',
  'bookings.filter_all': 'Alle Strome',
  'bookings.table_client': 'Kliëntnaam',
  'bookings.table_stream': 'Diens / Stroom',
  'bookings.table_date': 'Datum',
  'bookings.table_amount': 'Bedrag',
  'bookings.table_status': 'Status',
  'bookings.table_actions': 'Aksies',
  'bookings.mark_paid': 'Merk as Betaal',
  'bookings.mark_unpaid': 'Merk as Onbetaal',
  'bookings.delete': 'Verwyder',
  'bookings.no_records': 'Geen besprekings gevind nie. Gebruik "Voeg Bespreking By" hierbo.',

  // Invoices View
  'invoices.title': '📄 Kliëntfakture & Debiteure',
  'invoices.subtitle': 'Professionele fakturering en betalingsrekonsiliasie',
  'invoices.create_invoice': 'Skep Nuwe Faktuur',
  'invoices.tab_all': 'Alle Fakture',
  'invoices.tab_paid': 'Betaalde Fakture',
  'invoices.tab_outstanding': 'Uitstaande / Hangend',
  'invoices.tab_overdue': 'Agterstallig',
  'invoices.table_number': 'Faktuurnommer',
  'invoices.table_client': 'Kliënt',
  'invoices.table_issue_date': 'Uitreikingsdatum',
  'invoices.table_due_date': 'Vervaldatum',
  'invoices.table_total': 'Totale Bedrag',
  'invoices.table_status': 'Status',
  'invoices.download_pdf': 'Laai PDF Af',
  'invoices.mark_as_paid': 'Merk Betaal',
  'invoices.no_records': 'Nog geen fakture gegenereer nie. Skep ’n faktuur om debiteure na te speur.',

  // Expenses View
  'expenses.title': '💳 Besigheidsuitgawes & Grootboek',
  'expenses.subtitle': 'Uitvloeinaspeuring en wettige belastingaftrekkingsoptimalisering',
  'expenses.log_expense': 'Teken Uitgawe Aan',
  'expenses.import_csv': 'Voer CSV In',
  'expenses.total_outflow': 'Totale Uitvloei',
  'expenses.tax_deductible': 'Belastingaftrekbaar',
  'expenses.search_placeholder': 'Soek volgens verskaffer of beskrywing...',
  'expenses.filter_all': 'Alle Kategorieë',
  'expenses.table_category': 'Kategorie',
  'expenses.table_description': 'Beskrywing / Verskaffer',
  'expenses.table_date': 'Datum',
  'expenses.table_claimable': 'Belasting-aftrekbaar',
  'expenses.table_amount': 'Bedrag',
  'expenses.table_actions': 'Aksies',
  'expenses.claimable_yes': 'Ja (Aftrekbaar)',
  'expenses.claimable_no': 'Nee (Persoonlik / Nie-aftrekbaar)',
  'expenses.no_records': 'Nog geen uitgawes aangeteken nie. Voeg besigheidskoste by om regte netto marges te bereken.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Daaglikse Fokus & Inkomste-aksieplan',
  'focus.subtitle': 'Hoë-hefboom take wat wins, kliëntevloei en momentum bou',
  'focus.add_task': 'Voeg Inkomstetaak By',
  'focus.active_tasks': 'Aktiewe Prioriteite',
  'focus.completed_tasks': 'Voltooide Take',
  'focus.high_leverage': 'Hoë Prioriteit',
  'focus.mark_done': 'Voltooi',
  'focus.delete_task': 'Verwyder',
  'focus.no_tasks': 'Alles afgehandel! Voeg ’n nuwe inkomstetaak by om momentum te behou.',

  // Automated Operational Engine
  'ai.title': '⚡ Geoutomatiseerde Operasionele Enjin',
  'ai.subtitle': 'Kliëntkant-geënkripteerde berekeninge en soewereine operasionele intelligensie (Geen databerging)',
  'ai.ask_placeholder': 'Vra oor kontantvloei, marge-optimalisering of prysstrategie...',
  'ai.send': 'Ontleed',
  'ai.thinking': 'Die operasionele enjin verwerk jou finansiële berekeninge...',
  'ai.prompt_margin': 'Hoe kan ek my netto winsmarge tot 60% verhoog?',
  'ai.prompt_tax': 'Watter uitgawes moet ek eis om my belastingbuffer te optimaliseer?',
  'ai.prompt_pricing': 'Hoe moet ek my maandelikse konsultasiepakkette struktureer?',
  'ai.clear_chat': 'Maak Geskiedenis Skoon',

  // Business & Tax HQ
  'hq.title': '🏢 Besigheid- & Belasting-HK',
  'hq.subtitle': 'Profiel, geldeenheid, BTW-reëls, streeksvoorinstellings en geoktrooieerde ouditstate',
  'hq.tab_profile': 'Profiel & Identiteit',
  'hq.tab_currency_tax': 'Geldeenheid & Belastingreëls',
  'hq.tab_accountant_view': 'Rekenmeester & GR(SA) Ouditoorsig',
  'hq.tab_exports': 'Uitvoere & Rugsteun',
  'hq.tab_security': 'Sekuriteit & Beskerming',
  'hq.jurisdiction_preset_title': 'Streeksjurisdiksie-voorinstelling',
  'hq.jurisdiction_preset_desc': 'Kies jou land om plaaslike geldeenheid, BTW-koerse en belastingowerheid (SAID/SARS) outomaties op te stel.',
  'hq.accountant_view_title': 'Rekenmeester & GR(SA) Ouditoorsig',
  'hq.accountant_view_desc': 'Gestandaardiseerde voor-rekeningkundige opsomming gereed vir eksterne rekenmeesters of bankoudits.',
  'hq.export_pdf_audit': 'Drukbare PDF Ouditstaat',
  'hq.export_csv_audit': 'Voer Oudit-CSV Uit',
  'hq.currency_symbol': 'Geldeenheidsimbool',
  'hq.currency_code': 'Geldeenheidskode',
  'hq.vat_rate': 'BTW-koers (%)',
  'hq.tax_authority': 'Naam van Belastingowerheid',
  'hq.save_settings': 'Stoor Besigheidsinstellings',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Bruto Inkomste',
  'metric.total_expenses': 'Totale Uitgawes',
  'metric.net_profit': 'Netto Bedryfsinkomste',
  'metric.profit_margin': 'Bedryfswinsmarge',
  'metric.active_bookings': 'Aktiewe Besprekings',
  'metric.paid_invoices': 'Betaalde Fakture',
  'metric.unpaid_invoices': 'Uitstaande Fakture',
  'metric.tax_buffer': 'Beraamde Belastingbuffer',
  'metric.currency': 'Bedryfsgeldeenheid',
  'metric.tax_rate': 'BTW / Belastingkoers',

  // Actions & Common Buttons
  'btn.save': 'Stoor Veranderinge',
  'btn.cancel': 'Kanselleer',
  'btn.download': 'Aflaai',
  'btn.export_pdf': 'Laai Verslag as PDF Af',
  'btn.export_csv': 'Voer uit as CSV',
  'btn.cpa_pack': 'Voer Rekenmeesterpakket Uit',
  'btn.new_booking': 'Teken Bespreking Aan',
  'btn.new_expense': 'Teken Uitgawe Aan',
  'btn.add_task': 'Voeg Taak By',
  'btn.sync_calendar': 'Sinchroniseer Google Kalender',
  'btn.privacy_mode': 'Privaatheidsmodus',
  'btn.manage_subscription': 'Bestuur Intekening',
  'btn.sign_in': 'Teken In / Toegang',
  'btn.sign_out': 'Teken Uit',
  'btn.delete': 'Verwyder',
  'btn.edit': 'Wysig',
  'btn.close': 'Maak Toe',

  // Statuses
  'status.paid': 'Betaal',
  'status.unpaid': 'Uitstaande',
  'status.overdue': 'Agterstallig',
  'status.safe': 'Gesonde Marge',
  'status.warning': 'Marge-waarskuwing',
  'status.trial_active': 'Gratis Proeflopie Aktief',
  'status.pro_active': 'Sovereign Pro',
};
